module.exports = __webpack_public_path__ + "static/media/s28ru.9eebf74b.pdf";